import { getCurrentInstance } from "vue"

/**
 * Provides bound helpers for global $alert / $notify / $confirm methods
 * that are registered on app.config.globalProperties.
 *
 * Usage:
 *   const { alert, notify, confirm } = useGlobalMessaging()
 *   alert('Something happened')
 */
export function useGlobalMessaging() {
  const inst = getCurrentInstance()
  const proxy = inst?.proxy as any

  // Fallbacks emit console warnings so devs notice missing globals
  const alert = proxy?.$alert?.bind(proxy) ?? ((msg: any) => console.warn("Alert:", msg))
  const notify = proxy?.$notify?.bind(proxy) ?? ((opts: any) => console.warn("Notify:", opts))
  const confirm = proxy?.$confirm?.bind(proxy) ?? ((opts: any) => console.warn("Confirm:", opts))

  return { alert, notify, confirm }
}
